import { createApiHooks } from '@apis/next/common';
import { PaymentSlipLog } from '@models/next/PaymentSlipLog';
import { z } from 'zod';

export const dashboardPaymentSlipLogApis = createApiHooks('/dashboard/payment-slip-log', [
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: PaymentSlipLog.array(),
  },
]);
